// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FY1_G","questions":"styles_questions__oCHp-","footer":"styles_footer__36Cjl"};